<header>
  <div class="left-content">
    <a href="https://countable.co/" target="_blank" class="header-logo" tabindex="0"
      style="outline: none;border: none;">
      <img src="/assets/images/logo/countable-header-logo.svg" alt="Countable"/>
    </a>
  </div>
</header>
<div class="page-wrapper">
  <div class="page-title-block bg-white">
    <h1 class="title h3">Time Tracker</h1>
    <div class="button-group w-100">
      <button mat-button mat-stroked-button color="dark" class="button-medium me-auto" (click)="openManualtimeEntryDialog()">
        <span class="flexbox-row gap-8">
            <i class="fa-solid fa-plus"></i>
            <span class="button-label">Manual Time Entry</span>
        </span>
        </button>
      <button mat-button mat-stroked-button color="dark" class="button-medium" [disabled]="isDisableSubmitBtn" (click)="!isDisableSubmitBtn ? submitTime():''">
        <span class="flexbox-row gap-8">
            <i class="fa-regular fa-circle-check"></i>
            <span class="button-label">Submit Time</span>
        </span>
        </button>
      <button mat-button mat-stroked-button class="button-medium" color="dark" [disabled]="isDisableDeleteBtn" (click)="!isDisableDeleteBtn ? openDeletetimeEntryDialog('multi'):''">
        <span class="flexbox-row gap-8">
            <i class="fa-regular fa-trash-can"></i>
            <span class="button-label">Delete</span>
        </span>
    </button>
    </div>
  </div>
  <div class="mytime-tracker-body content-block-main">
    <ng-container *ngIf="true">
      <div class="card table-responsive">
      <table mat-table class="table-countable" style="position: sticky;top: 0;z-index: 5;">
        <ng-container matColumnDef="checkbox">
          <th mat-header-cell *matHeaderCellDef class="tracker-checkbox">
            <mat-checkbox [(ngModel)]="allEntriesCheked" (change)="multiCheck()"></mat-checkbox>
          </th>
        </ng-container>
        <ng-container matColumnDef="clientname">
          <th mat-header-cell *matHeaderCellDef class="tracker-client">
            <span>Client Name</span>
            <span>
              <button mat-icon-button class="filter-btn" [matMenuTriggerFor]="ClientNameFilter" [disabled]="timeEntries && timeEntries.length == 0">
                <i class="fa-solid fa-bars-filter fs-15"></i>
              </button>
            </span>
          </th>
        </ng-container>
        <ng-container matColumnDef="engagementid">
          <th mat-header-cell *matHeaderCellDef class="tracker-engid">
            <span>Engagement ID</span>
            <span>
              <button mat-icon-button class="filter-btn" [matMenuTriggerFor]="EngagementNameFilter" [disabled]="timeEntries && timeEntries.length == 0">
                <i class="fa-solid fa-bars-filter fs-15"></i>
              </button>
            </span>
          </th>
        </ng-container>
        <ng-container matColumnDef="category">
          <th mat-header-cell *matHeaderCellDef class="tracker-category">
            <span>Category</span>
            <span>
              <button mat-icon-button class="filter-btn" [matMenuTriggerFor]="categoryFilter" [disabled]="timeEntries && timeEntries.length == 0">
                <i class="fa-solid fa-bars-filter fs-15"></i>
              </button>
            </span>
          </th>
        </ng-container>
        <ng-container matColumnDef="type">
          <th mat-header-cell *matHeaderCellDef class="tracker-Type">
            Type
              <button mat-icon-button class="filter-btn" [matMenuTriggerFor]="timeTypeFilter" [disabled]="timeEntries && timeEntries.length == 0">
                <i class="fa-solid fa-bars-filter fs-15"></i>
              </button>
          </th>
        </ng-container>
        <ng-container matColumnDef="billable">
          <th mat-header-cell *matHeaderCellDef class="tracker-bill">
            <span>Billable</span>
            <span>
              <button mat-icon-button class="filter-btn" [matMenuTriggerFor]="billTypeFilter" [disabled]="timeEntries && timeEntries.length == 0">
                <i class="fa-solid fa-bars-filter fs-15"></i>
              </button>
            </span>
          </th>
        </ng-container>
        <ng-container matColumnDef="starttime">
          <th mat-header-cell *matHeaderCellDef class="tracker-duration"> Start Time </th>
        </ng-container>
        <ng-container matColumnDef="endtime">
          <th mat-header-cell *matHeaderCellDef class="tracker-duration"> End Time </th>
        </ng-container>
        <ng-container matColumnDef="duration">
          <th mat-header-cell *matHeaderCellDef class="tracker-duration"> Duration</th>
        </ng-container>
        <ng-container matColumnDef="notes">
          <th mat-header-cell *matHeaderCellDef class="tracker-notes">Notes</th>

        </ng-container>
        <ng-container matColumnDef="actions" stickyEnd>
          <th mat-header-cell *matHeaderCellDef class="col-actions text-end pe-2 ps-3 tracker-actions">
            Actions
            <span>
            <button mat-button class="button-small-icon" title="Collapse All" (click)="isEntryExpanded=false;togglePannels('C');"
              *ngIf="isEntryExpanded">
              <i class="fa-regular fa-arrow-up-right-and-arrow-down-left-from-center fs-3 text-primary"></i>
            </button>
            <button mat-button class="button-small-icon" title="Expand All" (click)="isEntryExpanded=true;togglePannels('E');"
              *ngIf="!isEntryExpanded">
              <i class="fa-regular fa-arrow-down-left-and-arrow-up-right-to-center fs-3 text-primary"></i>
            </button>
          </span>
          </th>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns;sticky: true"></tr>
      </table>
      <div class="mytime-tracker-details">

        <mat-accordion class="mytime-tracker-accordion" multi="true">
          <ng-container *ngFor="let entry of timeEntries; trackBy: trackByEntries;">
          <mat-expansion-panel class="mytime-tracker-panel" [expanded]="isEntryExpanded" *ngIf="entry.timeEntries && entry.timeEntries.length > 0">
            <mat-expansion-panel-header class="mytime-tracker-panel-header cut-p">
              <mat-checkbox [(ngModel)]="entry.parentChecked" (change)="singleCheck('parent', entry)" (click)="$event.stopPropagation();"></mat-checkbox>
              <span class="ps-2">
                <i class="fa-regular fa-calendar"></i>
            </span>&nbsp; {{entry.days}}&nbsp;({{entry.timeEntries?.length}})
            </mat-expansion-panel-header>
            <table mat-table [dataSource]="entry.timeEntries" class="">
              <ng-container matColumnDef="checkbox">
                <td mat-cell *matCellDef="let element" class="tracker-checkbox">
                  <mat-checkbox [(ngModel)]="element.checked" (change)="singleCheck('child', entry, element)"></mat-checkbox>
                </td>
              </ng-container>
              <ng-container matColumnDef="clientname">
                <td mat-cell *matCellDef="let element" class="tracker-client" title="{{element.engagementName}}">
                  {{element.clientName}}
                </td>
              </ng-container>
              <ng-container matColumnDef="engagementid">
                <td mat-cell *matCellDef="let element" class="tracker-engid">
                  <p class="ellipse no-marg">{{element.engagementName}}</p>
                </td>
              </ng-container>
              <ng-container matColumnDef="category">
                <td mat-cell *matCellDef="let element" class="tracker-category" title="{{element.submoduleName}}">
                  <p class="ellipse no-marg"> {{element.submoduleName}}</p>
                </td>
              </ng-container>
              <ng-container matColumnDef="type">
                <td mat-cell *matCellDef="let element" class="tracker-Type">
                  <p class="ellipse no-marg"> {{element.type}}<span class="badge-error badge-small badge-pills badge-border badge"
                      *ngIf="element.isIdleTime == 1">Idle</span></p>
                </td>
              </ng-container>
              <ng-container matColumnDef="billable">
                <td mat-cell *matCellDef="let element" class="tracker-bill">
                  <p class="ellipse no-marg"> {{element.entryName}}</p>
                </td>
              </ng-container>
              <ng-container matColumnDef="starttime">
                <td mat-cell *matCellDef="let element" class="tracker-duration">
                  <p class="ellipse no-marg"> {{element.startTime}} </p>
                </td>
              </ng-container>
              <ng-container matColumnDef="endtime">
                <td mat-cell *matCellDef="let element" class="tracker-duration">
                  <p class="ellipse no-marg"> {{element.endTime}} </p>
                </td>
              </ng-container>
              <ng-container matColumnDef="duration">
                <td mat-cell *matCellDef="let element" class="tracker-duration">
                  <p class="ellipse no-marg">{{element.duration}}</p>
                </td>
              </ng-container>
              <ng-container matColumnDef="notes">
                <td mat-cell *matCellDef="let element" class="tracker-notes" title="{{element.notes}}">
                  <p class="ellipse no-marg">{{element.notes}}</p>
                </td>

              </ng-container>
              <ng-container matColumnDef="actions" stickyEnd>
                <td mat-cell *matCellDef="let element" class="tracker-actions">
                  <div class="actions-items">
                    <button title="Edit" class="transparent-btn" (click)="openActivetimeEntryDialog(element)">
                        <i class="fa-regular fa-pen fs-15"></i>
                    </button>
                    <button title="Delete" class="transparent-btn" [disabled]="element.timeTrackingTypeId == 1" (click)="element.timeTrackingTypeId == 2 ? openDeletetimeEntryDialog('single', element): ''">
                        <i class="fa-regular fa-trash-can"></i>
                    </button>
                    <button title="Submit" class="transparent-btn" (click)="submitSingleEntry(element)">
                        <i class="fa-regular fa-circle-check"></i>
                    </button>
                  </div>
                </td>
              </ng-container>
              <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>
          </mat-expansion-panel>
        </ng-container>
        </mat-accordion>
      </div>
    </div>

      <div class="no-time-msg" *ngIf="timeEntries && timeEntries.length == 0">
        <p>Time has not yet been logged</p>
      </div>
      <div class="no-time-msg" *ngIf="showNoRecords">
        <p>No Records Found</p>
      </div>
    </ng-container>
  </div>
</div>
<ng-template #deletetimeentry>
  <div class="countable-dialog confirmation-dailog" style="width: 400px;">
    <div mat-dialog-title class="dialog-header d-flex flex-column align-items-center p-0">
        <span class="badge badge-error badge-circle icon-bordered-error">
            <i class="fa-regular fa-trash-can text-error"></i>
        </span>

      <h4 class="title text-center">Delete</h4>
      <button color="error" class="close" [mat-dialog-close]="false">
        <i class="fa-regular fa-xmark clear-icon"></i>
    </button>
    </div>
    <div mat-dialog-content class="content dialog-body-content text-center gap-8 mt-2 mb-32">
      <p>{{deleteTitle}}</p>
    </div>
    <div mat-dialog-actions class="dialog-footer button-group w-100">
      <button mat-button mat-stroked-button class="button-normal flex-1" color="dark" [mat-dialog-close]>Cancel</button>
      <button mat-button mat-flat-button class="button-normal flex-1 m-0" color="error" [mat-dialog-close] (click)="deleteType === 'single' ? deleteTimeEntry('single'):deleteTimeEntry('multi')">Delete</button>

    </div>
  </div>
</ng-template>
<ng-template #manualtimeentry>
  <div class="countable-dialog" style="width: 800px;">
    <div mat-dialog-title class="dialog-header manual-time-entry-header">
      <h4 class="title">{{editTitle}}</h4>
    </div>
    <form autoComplete="off" [formGroup]="manualForm" class="m-4">
        <div class="form-group row-item-2">

             <div class="form-item fixed-label icon-field-after"  >
              <app-countable-date  [isMaxDate]="true" [inputMaxDate]="maxIncorpDate" (selectedDate)="checkDates($event)"
                [label]="'Date'" [placeholderText]="customDateTitle + '(MM/DD/YYYY)'"
                [inputDate]="manualForm.controls['createdDate'].value" ></app-countable-date>
            </div>

            <ng-container>
            <div class="form-item ng-form-field">
            <label>Entry Type<span style="color:#F5564B">*</span></label>
            <ng-select [items]="entries" bindLabel="entryName" bindValue="timeTrackingEntryId"
              [multiple]="false" [selectOnTab]="true" [clearable]="false"
              (change)="getCategories($event, setNull = true);enableDisableDropdown($event, 'entryType')" formControlName="entryType" required>
            </ng-select>
            </div>
        </ng-container>

        <mat-form-field floatLabel="always" class="form-item fixed-label">
            <mat-label> Team Member:</mat-label>
            <input matInput value="{{fullName}} ({{roleName}})" />
          </mat-form-field>

          <ng-container>
            <div class="form-item ng-form-field">
            <label>Client Name<span style="color:#F5564B" [ngStyle]="{'display': getValue('entryType') == 1 ? 'inline':'none'}">*</span></label>
            <ng-select (keydown.arrowdown)="$event.stopPropagation()" (keydown.arrowup)="$event.stopPropagation()"
              [items]="clients" bindLabel="clientName" bindValue="clientFirmId"
              [multiple]="false" [selectOnTab]="true" [clearable]="false" [virtualScroll]="true"
              (change)="getEngagements($event, setNull = true)" formControlName="clientName" required>
            </ng-select>
            </div>
        </ng-container>

        <ng-container>
            <div class="form-item ng-form-field">
            <label>Engagement ID<span style="color:#F5564B" [ngStyle]="{'display': getValue('entryType') == 1 ? 'inline':'none'}">*</span></label>
            <ng-select [items]="engagements" bindLabel="engagementName"
              bindValue="engagementsId" [multiple]="false" [selectOnTab]="true" [clearable]="false"
              [virtualScroll]="true" formControlName="engagementId" required>
            </ng-select>
          </div>
        </ng-container>

        <mat-form-field floatLabel="always" *ngIf="isEdit && (singleEntryData.timeTrackingTypeId == 1 || singleEntryData.isIdleTime == 1)" class="form-item fixed-label">
            <mat-label> Category</mat-label>
            <input matInput value="{{singleEntryData.submoduleName}}" />
          </mat-form-field>

          <ng-container *ngIf="(isEdit && singleEntryData.timeTrackingTypeId == 2) || !isEdit">
            <div class="form-item ng-form-field">
            <label>Category<span style="color:#F5564B">*</span></label>
            <ng-select [items]="categories"  bindLabel="timeCategoryName"
              bindValue="timeCategoryId" [multiple]="false" [selectOnTab]="true" [clearable]="false"
              [virtualScroll]="true" formControlName="category" required>
            </ng-select>
          </div>
        </ng-container>

        <ng-container>
            <div class="form-item ng-form-field">
                <label>Start Time<span style="color:#F5564B" [ngStyle]="{'display': isEdit && (singleEntryData.timeTrackingTypeId == 1 || singleEntryData.isIdleTime == 1) ? 'none':'inline'}">*</span></label>
              <ng-select class="map-head-dropdown firm-input-field time-dropdown" [items]="timeData" bindLabel="time"
                bindValue="time" [multiple]="false" [selectOnTab]="true" [clearable]="false"
                formControlName="startTime" (change)="enableDisableDropdown($event, 'startTime')" required>
              </ng-select>
            </div>
        </ng-container>

        <ng-container>
            <div class="form-item ng-form-field">
                <label>End Time<span style="color:#F5564B" [ngStyle]="{'display': isEdit && (singleEntryData.timeTrackingTypeId == 1 || singleEntryData.isIdleTime == 1) ? 'none':'inline'}">*</span></label>
              <ng-select class="map-head-dropdown firm-input-field time-dropdown" [items]="timeData" bindLabel="time"
                bindValue="time" [multiple]="false" [selectOnTab]="true" [clearable]="false"
                formControlName="endTime" (change)="timeDiffCalc()" required>
              </ng-select>
            </div>
        </ng-container>

          <mat-form-field floatLabel="always" class="form-item fixed-label">
            <mat-label> Duration</mat-label>
            <input matInput value="{{duration}}"/>
          </mat-form-field>

          <mat-form-field floatLabel="always" class="form-item fixed-label">
            <mat-label> Notes</mat-label>
            <textarea matInput formControlName="notes"></textarea>
          </mat-form-field>
        <!-- <div class="row-1">
          <p class="heading">
            Notes<span style="color:#F5564B">*</span>
          </p>
          <textarea class="details-textarea" formControlName="notes"
            formControlName="notes"></textarea>
        </div> -->

      <div mat-dialog-actions class="dialog-footer">
        <button mat-button mat-stroked-button class="button-medium" color="dark" [mat-dialog-close] (click)="resetForm()">Cancel</button>
        <button mat-button mat-flat-button class="button-medium" color="primary" [mat-dialog-close] [disabled]="!manualForm.valid"
          (click)="isEdit ? updateTimeEntry() : saveManualTime()">{{isEdit ? 'Update' : 'Add'}}</button>
      </div>
    </div>
    </form>
  </div>
</ng-template>

<!--Client Name filter-->
<mat-menu #ClientNameFilter="matMenu" xPosition="after">
  <div (click)="$event.stopPropagation()">
    <button mat-menu-item class="cust-fontcol" (click)="clearFilters('client')"><span class="cust-p">Clear All</span></button>
      <button mat-menu-item class="time-filter-btn" *ngFor="let client of filterClientData">
        <mat-checkbox [(ngModel)]="client.checked" (change)="filterViewTimeEntries()">
          <p class="ellipse no-marg">{{client.clientName}}</p>
        </mat-checkbox>
      </button>
  </div>
</mat-menu>
<mat-menu #EngagementNameFilter="matMenu" class="filterContent time-filter-menu" xPosition="after">
  <div class="tbl-scroll" (click)="$event.stopPropagation()">
    <button mat-menu-item class="cust-fontcol" (click)="clearFilters('eng')"> <span class="cust-p">Clear All</span></button>
      <button mat-menu-item class="time-filter-btn" *ngFor="let eng of filterEngs">
        <mat-checkbox [(ngModel)]="eng.checked" (change)="filterViewTimeEntries()">
          <p class="ellipse no-marg">{{eng.engagementName}}</p>
        </mat-checkbox>
      </button>
  </div>
</mat-menu>
<mat-menu #categoryFilter="matMenu" class="filterContent time-filter-menu" xPosition="after">
  <div class="tbl-scroll" (click)="$event.stopPropagation()">
    <button mat-menu-item class="cust-fontcol" (click)="clearFilters('cat')"><span class="cust-p">Clear All</span></button>
      <button mat-menu-item class="time-filter-btn" *ngFor="let cat of filterCategories">
        <mat-checkbox [(ngModel)]="cat.checked" (change)="filterViewTimeEntries()">
          <p class="ellipse no-marg">{{cat.submoduleName}}</p>
        </mat-checkbox>
      </button>
  </div>
</mat-menu>
<mat-menu #timeTypeFilter="matMenu" class="filterContent time-filter-menu" xPosition="after">
  <div class="tbl-scroll" (click)="$event.stopPropagation()">
    <button mat-menu-item class="cust-fontcol" (click)="clearFilters('type')"><span class="cust-p">Clear All</span></button>
      <button mat-menu-item class="time-filter-btn" *ngFor="let type of filterTimeType">
        <mat-checkbox [(ngModel)]="type.checked" (change)="filterViewTimeEntries()">
          <p class="ellipse no-marg">{{type.type}}</p>
        </mat-checkbox>
      </button>
  </div>
</mat-menu>
<mat-menu #billTypeFilter="matMenu" class="filterContent time-filter-menu" xPosition="after">
  <div class="tbl-scroll" (click)="$event.stopPropagation()">
    <button mat-menu-item class="cust-fontcol" (click)="clearFilters('btype')"><span class="cust-p">Clear All</span></button>
      <button mat-menu-item class="time-filter-btn" *ngFor="let bType of typesFilter">
        <mat-checkbox [(ngModel)]="bType.checked" (change)="filterViewTimeEntries()">
          <p class="ellipse no-marg">{{bType.entryName}}</p>
        </mat-checkbox>
      </button>
  </div>
</mat-menu>
